import { NotFoundComponent } from '@/app/components/404/not-found';

export default NotFoundComponent;
